import { CompactRecentMatches } from "components/Matches/Compact/CompactRecentMatches";
import { CompactUpcomingMatches } from "components/Matches/Compact/CompactUpcomingMatches";
import { Panel } from "components/Panel/Panel";
import { Column, GrowColumn } from "pages/styles";
import { useState } from "react";
import { COMPACT_COL_WIDTH } from "theme";
import { MatchViewer } from "components/MatchViewer/MatchViewer";
import { TrackTimes } from "components/MatchViewer/TrackTimes/TrackTimes";
import { MultiColumnPage } from "pages/PageTemplates";
import { Match } from "model/Match/Match";

const RECENT_MATCHES_AMOUNT = 8;
const UPCOMING_MATCHES_AMOUNT = 8;

interface Props {
  match: Match;
  tournamentId: string;
}
export const MatchPageContent = ({ match, tournamentId }: Props) => {
  const [selectedSetIdx, setSelectedSetIdx] = useState<number | undefined>(
    (match.sets.length ?? 0) > 0 ? 0 : undefined
  );

  const selectedSet =
    selectedSetIdx !== undefined ? match.sets[selectedSetIdx] : undefined;

  return (
    <>
      <MultiColumnPage>
        {/* todo - extract common panels, e.g Recent Matches in multiple places with name etc. */}
        <Column
          style={{
            minWidth: COMPACT_COL_WIDTH,
            maxWidth: COMPACT_COL_WIDTH,
          }}
          hideUnderWidth={1000}
        >
          <Panel header="Recent Matches">
            <CompactRecentMatches amount={RECENT_MATCHES_AMOUNT} />
          </Panel>
        </Column>
        <GrowColumn>
          <MatchViewer
            match={match}
            tournamentId={tournamentId}
            selectedSetIdx={selectedSetIdx}
            setSelectedSetIdx={setSelectedSetIdx}
          />
        </GrowColumn>
        <Column
          style={{
            minWidth: COMPACT_COL_WIDTH,
            maxWidth: COMPACT_COL_WIDTH,
          }}
          hideUnderWidth={1200}
        >
          <Panel header="Upcoming Matches">
            <CompactUpcomingMatches amount={UPCOMING_MATCHES_AMOUNT} />
          </Panel>
        </Column>
      </MultiColumnPage>
      {!!selectedSet && (
        <TrackTimes
          set={selectedSet}
          teams={match.teams}
          tournamentId={tournamentId}
        />
      )}
    </>
  );
};
